<template>
  <div>
    <a
      v-if="url"
      id="spmPort"
      :href="url"
      v-view="view"
      v-report="report"
      v-query="`${spm}${index?`.${index}`:''}`"
      target="_blank"
    >
      <slot />
    </a>
    <a v-else id="spmPort" v-view="view" v-report="report" target="_blank">
      <slot />
    </a>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
    },
    // 跳转链接后挂在spm
    spm: {
      type: String,
    },
    // spm第五位
    index: {
      type: Number,
    },
    // 点击上报spm
    // 传参类型："x.x.x.x" | ["x.x.x.x", index] | { spm: "x.x.x.x", dest: "http://...", index }
    report: {
      type: Object,
    },
    // 点击上报spm
    // 传参类型："x.x.x.x" | ["x.x.x.x", index] | { spm: "x.x.x.x", dest: "http://...", index }
    view: {
      type: Object,
    },
  },
};
</script>

<style>
</style>